import { render } from "./ObjBar.vue?vue&type=template&id=c4d906a4"
import script from "./ObjBar.vue?vue&type=script&lang=js"
export * from "./ObjBar.vue?vue&type=script&lang=js"

import "./ObjBar.vue?vue&type=style&index=0&id=c4d906a4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__